// src/features/auth/utils/authSession.ts

import {
  getEmployeeId,
  getEmployeeCode,
  getEmployeeName,
  getRole,
  getToken,
} from './authStorage';

export const AuthSession = {
  currentEmployee: () => getEmployeeCode(), // ✅ Changed here

  employeeId: () => getEmployeeId(),

  employeeCode: () => getEmployeeCode(),

  employeeName: () => getEmployeeName(),

  role: () => getRole(),

  token: () => getToken(),
};